export const formatSSRData = (
  seatArray: any,
  mealData: any,
  baggageData: any,
  wheelchairData: any,
  flight: any
) => {
  const result: any[] = [];
  const segmentCounters: Record<string, number> = {};
  seatArray?.forEach((seat: any) => {
    const segmentKey = `${seat.Flight_ID}-${seat.segmentindex}`;
    if (flight?.Flight?.Flight_Id === seat?.Flight_ID) {
      if (!segmentCounters[segmentKey]) {
        segmentCounters[segmentKey] = 1;
      }
      result.push({
        SSR_Key: seat?.SSR_Key,
        Pax_Id: segmentCounters[segmentKey]++,
      });
    }
  });
  const processSSRData = (data: any) => {
    Object.entries(data)?.forEach(([paxKey, ssrItems]: any) => {
      const paxId = parseInt(paxKey, 10) + 1;
      Object.values(ssrItems)?.forEach((ssr: any) => {
        if (flight?.Flight?.Flight_Id === ssr?.Flight_ID) {
          result.push({
            SSR_Key: ssr?.SSR_Key,
            Pax_Id: paxId,
          });
        }
      });
    });
  };
  processSSRData(mealData);
  processSSRData(baggageData);
  processSSRData(wheelchairData);
  return result;
};

export const groupSSRBySegment = (ssrData: any) => {
  const result: any[] = [];
  ssrData?.forEach((routeItem: any) => {
    const segmentMap: any = new Map();
    routeItem.SSRDetails?.forEach((ssr: any) => {
      const key = `${ssr.Flight_ID}_${ssr.Segment_Id}`;
      if (!segmentMap.has(key)) {
        segmentMap.set(key, []);
      }
      segmentMap.get(key).push(ssr);
    });
    for (const [, ssrList] of segmentMap) {
      result.push({ SSRDetails: ssrList });
    }
  });
  return result;
};

export const getTotalSSRCount = (selectedSSRs: any): number => {
  let count = 0;
  Object.values(selectedSSRs)?.forEach((paxSSR: any) => {
    Object.values(paxSSR)?.forEach((ssr: any) => {
      if (ssr) count++;
    });
  });
  return count;
}; 